// Dokumenty bez daty ważności (decyzja właściciela 15.10.2026): zdjęcia pojazdu
// i niekaralność opisują stan na dzień zrobienia/wydania. Ta sama lista co
// w backendzie (dokumenty-bez-waznosci.ts) — serwer i tak ignoruje dla nich datę.
export const DOKUMENTY_BEZ_WAZNOSCI = [
  'VEHICLE_PHOTO_FRONT',
  'VEHICLE_PHOTO_BACK',
  'CRIMINAL_RECORD',
  'CRIMINAL_RECORD_FOREIGN',
  'CRIMINAL_RECORD_TRANSLATION',
];

export const maDateWaznosci = (typ) => !DOKUMENTY_BEZ_WAZNOSCI.includes(typ);
